import { CopyIdButton } from 'components/copy-id-button';
import { IconBlock } from '@hqo/react-components-library/dist/molecules/iconBlock';
import { Value } from './styles';
import { useIntl } from 'react-intl';
import { useIsExternalIdVisible } from './use-external-id.hook';

interface Props {
  orderNumber?: string;
  className?: string;
}

export const OrderNumberField = ({ orderNumber, className }: Props): JSX.Element | null => {
  const intl = useIntl();
  const isVisible = useIsExternalIdVisible(orderNumber);

  if (!isVisible) {
    return null;
  }

  return (
    <IconBlock
      className={className}
      dataTestId="order-number"
      dataCy="order-number"
      icon="clipboard-list"
      iconType="far"
      titleType="bold"
      title={intl.formatMessage({ id: 'order_number' })}
      subtitle={
        <Value>
          {orderNumber}
          <CopyIdButton value={orderNumber} />
        </Value>
      }
    />
  );
};
